export const getLocationReferral = () => {
  return (
    window.location.pathname + window.location.search + window.location.hash
  );
};
